exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-balloon-panel {\n\tz-index: 2000 !important;\n}", ""]);

// exports
